import { useEffect, useRef } from "react";
import { handleLogoutUser } from "./Logout";


export const useIdleLogout = (keycloak, timeout = 10 * 60 * 1000) => {
  const timer = useRef(null);

  const resetTimer = () => {
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      logoutUser();
    }, timeout);
  };

  const logoutUser = async () => {
    try {
      await handleLogoutUser(keycloak);
    } catch (error) {
      console.error("Auto Logout Error:", error?.message || error);
    }
  };

  useEffect(() => {
    const events = ["mousemove", "mousedown", "keypress", "touchmove", "scroll"];
    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer(); // Start timer initially

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);
};
 